import { actions } from './services';
import {getUserFromLS, deleteUserFromLS, setUserToLS} from '@/helpers/userHelper';

let initialState;
const getInitialState = () => {
  if (!initialState) {
    initialState = {
      user: getUserFromLS(),
      landingPage: {
        referer: '',
        path: '/',
        params: {}
      },
      isLoading: false
    };
  }
  return initialState;
};

//by default => initial state
const state = getInitialState();

const mutations = {
  logIn: (state, user) => {
    state.isLoading = false;
    state.user = { ...state.user, ...user };
    setUserToLS(state.user);
  },
  setLandingPage: (state, landingPage) => {
    state.landingPage = { ...state.landingPage, ...landingPage };
  },
  logOut: state => {
    state = Object.assign(state, getInitialState());
    deleteUserFromLS();
  },
  startLoading: state => {
    state.isLoading = true;
  }
};
const getters = {
  isConnected: state => state.user.identity.token !== '',
  isLoading: state => state.isLoading
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
